import { useParams } from 'react-router-dom';

import { useGetGame } from '@/api/getGames';
import type { Game } from '@/models/game';

export const useGame = (): Game => {
  const { gameCode } = useParams();
  if (gameCode == null) {
    throw new Error('Game code is required'); //developer error, should never happen
  }

  const { data: game } = useGetGame(gameCode);

  if (!game) {
    throw new Error(`Game ${gameCode} not found`); //developer error, should never happen
  }

  return game;
};
